import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'

import {
  FETCH_MOST_ACCESSED_MENUS_REQUEST,
  FETCH_MOST_ACCESSED_MENUS_SUCCESS_WEB,
  FETCH_MOST_ACCESSED_MENUS_SUCCESS_MOBILE,
  FETCH_MOST_ACCESSED_MENUS_ERROR,
  FETCH_DEVICES_UPDATE_REQUEST,
  FETCH_DEVICES_UPDATE_SUCCESS,
  FETCH_DEVICES_UPDATE_ERROR,
  FETCH_ACTIVE_INACTIVE_USERS_REQUEST,
  FETCH_ACTIVE_INACTIVE_USERS_SUCCESS,
  FETCH_ACTIVE_INACTIVE_USERS_ERROR,
  FETCH_LIST_MOST_ACCESSED_MENUS_MOBILE_REQUEST,
  FETCH_LIST_MOST_ACCESSED_MENUS_MOBILE_SUCCESS,
  FETCH_LIST_MOST_ACCESSED_MENUS_MOBILE_ERROR,
  FETCH_LIST_MOST_ACCESSED_MENUS_WEB_REQUEST,
  FETCH_LIST_MOST_ACCESSED_MENUS_WEB_SUCCESS,
  FETCH_LIST_MOST_ACCESSED_MENUS_WEB_ERROR,
} from 'actionTypes'

/*
 * REQUEST MOST_ACCESSED_MENUS
 */
export const fetchMostAccessedMenus = (auth, params) => (dispatch) => {
  dispatch(fetchMostAccessedMenusRequest())

  let type = FETCH_MOST_ACCESSED_MENUS_SUCCESS_MOBILE
  if (params.inWeb) {
    type = FETCH_MOST_ACCESSED_MENUS_SUCCESS_WEB
  }

  return new Api(auth.user.dsToken, dispatch)
    .post(API_URL.ANALYTICS_MENUS, params)
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(fetchMostAccessedMenusSuccess(response.data, type))
      dispatch(hideSpinner())
    })
    .catch((error) => {
      dispatch(fetchMostAccessedMenusError(error))
      dispatch(hideSpinner())
    })
}

export const fetchMostAccessedMenusRequest = () => ({
  type: FETCH_MOST_ACCESSED_MENUS_REQUEST,
})

export const fetchMostAccessedMenusSuccess = (data, type) => ({
  type,
  payload: data,
})

export const fetchMostAccessedMenusError = (error) => ({
  type: FETCH_MOST_ACCESSED_MENUS_ERROR,
  payload: error,
})

/*
 * REQUEST DEVICES_UPDATE
 */
export const fetchDevicesUpdate = (auth, params) => (dispatch) => {
  dispatch(fetchDevicesUpdateRequest())

  return new Api(auth.user.dsToken, dispatch)
    .post(API_URL.ANALYTICS_DEVICES, params)
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(fetchDevicesUpdateSuccess(response.data))
      dispatch(hideSpinner())
    })
    .catch((error) => {
      dispatch(fetchDevicesUpdateError(error))
      dispatch(hideSpinner())
    })
}

export const fetchDevicesUpdateRequest = () => ({
  type: FETCH_DEVICES_UPDATE_REQUEST,
})

export const fetchDevicesUpdateSuccess = (data) => ({
  type: FETCH_DEVICES_UPDATE_SUCCESS,
  payload: data,
})

export const fetchDevicesUpdateError = (error) => ({
  type: FETCH_DEVICES_UPDATE_ERROR,
  payload: error,
})

/*
 * REQUEST ACTIVE_INACTIVE_USERS
 */
export const fetchActiveInactiveUsers = (auth, params) => (dispatch) => {
  dispatch(fetchActiveInactiveUsersRequest())

  return new Api(auth.user.dsToken, dispatch)
    .get(API_URL.ANALYTICS_USERS, params)
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(fetchActiveInactiveUsersSuccess(response.data))
      dispatch(hideSpinner())
    })
    .catch((error) => {
      dispatch(fetchActiveInactiveUsersError(error))
      dispatch(hideSpinner())
    })
}

export const fetchActiveInactiveUsersRequest = () => ({
  type: FETCH_ACTIVE_INACTIVE_USERS_REQUEST,
})

export const fetchActiveInactiveUsersSuccess = (data) => ({
  type: FETCH_ACTIVE_INACTIVE_USERS_SUCCESS,
  payload: data,
})

export const fetchActiveInactiveUsersError = (error) => ({
  type: FETCH_ACTIVE_INACTIVE_USERS_ERROR,
  payload: error,
})

/*
 * REQUEST LIST_MOST_ACCESSED_MENUS_MOBILE
 */
export const fetchListMostAccessedMenusMobile =
  (auth, params) => (dispatch) => {
    dispatch(fetchListMostAccessedMenusMobileRequest())

    return new Api(auth.user.dsToken, dispatch)
      .post(API_URL.ANALYTICS_LIST_ACCESSES, params)
      .then(dispatch(showSpinner()))
      .then((response) => {
        dispatch(fetchListMostAccessedMenusMobileSuccess(response.data))
        dispatch(hideSpinner())
      })
      .catch((error) => {
        dispatch(fetchListMostAccessedMenusMobileError(error))
        dispatch(hideSpinner())
      })
  }

export const fetchListMostAccessedMenusMobileRequest = () => ({
  type: FETCH_LIST_MOST_ACCESSED_MENUS_MOBILE_REQUEST,
})

export const fetchListMostAccessedMenusMobileSuccess = (data) => ({
  type: FETCH_LIST_MOST_ACCESSED_MENUS_MOBILE_SUCCESS,
  payload: data,
})

export const fetchListMostAccessedMenusMobileError = (error) => ({
  type: FETCH_LIST_MOST_ACCESSED_MENUS_MOBILE_ERROR,
  payload: error,
})

/*
 * REQUEST LIST_MOST_ACCESSED_MENUS_WEB
 */
export const fetchListMostAccessedMenusWeb = (auth, params) => (dispatch) => {
  dispatch(fetchListMostAccessedMenusWebRequest())

  return new Api(auth.user.dsToken, dispatch)
    .post(API_URL.ANALYTICS_LIST_ACCESSES, params)
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(fetchListMostAccessedMenusWebSuccess(response.data))
      dispatch(hideSpinner())
    })
    .catch((error) => {
      dispatch(fetchListMostAccessedMenusWebError(error))
      dispatch(hideSpinner())
    })
}

export const fetchListMostAccessedMenusWebRequest = () => ({
  type: FETCH_LIST_MOST_ACCESSED_MENUS_WEB_REQUEST,
})

export const fetchListMostAccessedMenusWebSuccess = (data) => ({
  type: FETCH_LIST_MOST_ACCESSED_MENUS_WEB_SUCCESS,
  payload: data,
})

export const fetchListMostAccessedMenusWebError = (error) => ({
  type: FETCH_LIST_MOST_ACCESSED_MENUS_WEB_ERROR,
  payload: error,
})
